import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { isNativeAndroid, isNativeIOS, requireAppUpdate } from './NativeUtil';
import { setPageview } from './ga';

export default function OnRouterChanged() {
  const location = useLocation();

  // 페이지 변경 시 GA 페이지뷰 전송
  useEffect(() => {
    setPageview(location.pathname + location.search);
  }, [location]);

  const shouldForceUpdate =
    location.pathname !== '/ask_update' &&
    (isNativeIOS() || isNativeAndroid()) &&
    requireAppUpdate();

  if (shouldForceUpdate) {
    return <Navigate to="/ask_update" replace />;
  }

  return <Outlet />;
}
